import React from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'

const Section = styled.section`
  max-width: 1152px;
  p {
    margin: 0 auto 1rem;
    text-align: center;
    max-width: 40em;
    width: 100%;
  }
  p:last-of-type {
    font-size: 1.5rem;
    margin-top: 2.5rem;
  }
`
const Map = styled.div`
  background: #32F095;
  border-radius: 4px;
  margin-top: 2.5rem;
  position: relative;
  overflow: hidden;
  a {
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
  }
  @media screen and (min-width: 960px) {
    & {
        padding-left: 24rem;
    }
    &::before {
        background: #32F095 url(img/lifeway.jpeg) no-repeat center right;
        background-size: cover;
        background-blend-mode: multiply;
        content: "";
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 24rem;
    }
  }
  iframe {
    display: block;
    height: 400px;
    width: 100%;
  }
`;


const Location = () => (
  <Section id="#location">
    <h2>Location</h2>
    <p>Conference will be held at LifeWay’s new Corporate Headquarters:</p>
    <p>
      1 Lifeway Plaza,<br />Nashville, TN
    </p>
    <Map>
      <a
        href="https://www.google.com/maps/dir/''/LifeWay+Christian+Store,+1+Lifeway+Plaza,+Nashville,+TN+37234/@36.1646242,-86.862663,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x886466f5d469c4f5:0x90f66d0a948e9bb7!2m2!1d-86.7926229!2d36.1646446"
        target="_blank"
        rel="noopener"
      />
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3221.078490041846!2d-86.79481158428592!3d36.16464458008447!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x886466f5d469c4f5%3A0x90f66d0a948e9bb7!2sLifeWay+Christian+Store!5e0!3m2!1sen!2sus!4v1526338426319"
        frameBorder="0"
        style={{ border: 0 }}
        allowFullScreen
      />
    </Map>
    <figure>
      <img src="" alt="" />
    </figure>
  </Section>
)

export default Location



// WEBPACK FOOTER //
// ./src/components/location.js